export const loginUrl = 'auth/login';
